
class MyCommitmentPermissions {
	canOutcomeBeCompleted() {
		return true;
	}

	canUserCompleteOutcome() {
		return true;
	}

	canUserAssignOutcome() {
		return false;
	}

	resolve() {
		return {
			canUserCompleteOutcome: this.canUserCompleteOutcome(),
			canUserAssignOutcome: this.canUserAssignOutcome(),
		};
	}
}

export default MyCommitmentPermissions;



// WEBPACK FOOTER //
// ./src/permissions/MyCommitmentPermissions.js